import { render, staticRenderFns } from "./CategoryProducts.vue?vue&type=template&id=31de2b00&"
import script from "./CategoryProducts.vue?vue&type=script&lang=ts&"
export * from "./CategoryProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports